import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

const ListEditor = ({ value = [], onChange }) => {
  const updateRow = (index, key, newValue) => {
    const updatedList = value.map((item, i) => 
      i === index ? { ...item, [key]: newValue } : item
    );
    onChange(updatedList);
  };
  const addRow = () => {
    const newRow = { name: '', description: '', expr: '' };
    onChange([...value, newRow]);
  };
  const removeRow = (index) => {
    const filteredList = value.filter((_, i) => i !== index);
    onChange(filteredList);
  };
  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '10px' }}>
        <thead>
          <tr style={{ textAlign: 'left', borderBottom: '2px solid #ccc' }}>
            <th>Name</th>
            <th>Description</th>
            <th>Expression</th>
            <th style={{ width: '50px' }}></th>
          </tr>
        </thead>
        <tbody>
          {value.map((row, index) => (
            <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
              <td>
                <input 
                  value={row.name} 
                  onChange={(e) => updateRow(index, 'name', e.target.value)}
                  placeholder="Name"
                />
              </td>
              <td>
                <input 
                  value={row.description} 
                  onChange={(e) => updateRow(index, 'description', e.target.value)}
                  placeholder="Description"
                />
              </td>
              <td>
                <input 
                  value={row.expr} 
                  onChange={(e) => updateRow(index, 'expr', e.target.value)}
                  placeholder="Expression"
                />
              </td>
              <td>
                <button onClick={() => removeRow(index)} style={{ color: 'red' }}>
                  ✖
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Button onClick={addRow}>
        + Add Row
      </Button>
    </div>
  );
};

const OrganizationManagementCVTDialog = ( props ) => {
  const [cvts, setCvts] = useState(JSON.parse(props?.organization?.predefined_cvts || "[]"));
  const modified = props.organization && props.organization.predefined_cvts !== JSON.stringify(cvts);
  
  return (
    <Grid>
      <Dialog
        open={!!(props.organization)}
        onClose={props.handleClose}
        aria-labelledby="form-dialog-title"
        maxWidth="lg"
      >
        <DialogTitle id="form-dialog-title">Organization Custom CVT Expressions</DialogTitle>
        <DialogContent>
          <ListEditor value={cvts} onChange={(v) => setCvts(v)}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=> props.handleClose(cvts)}
                  disabled={!modified} color="primary">
            Save
          </Button>
          <Button onClick={() => props.handleClose() } color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default OrganizationManagementCVTDialog;
